(function () {
  if (window.__productInfoStickyInitialized) return;
  window.__productInfoStickyInitialized = true;

  class LightweightSticky {
    constructor(element) {
      this.element = element;
      this.header = document.querySelector('.section-header');
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.cache = {
        viewportHeight: window.innerHeight,
        elementHeight: 0,
        headerHeight: 0
      };

      this.onScroll = this.onScroll.bind(this);
      this.measure = this.measure.bind(this);
      
      this.init();
    }

    init() {
      // 1. Initial measurement
      this.measure();
      
      // 2. IMPORTANT: Sync internal state with current CSS 'top' 
      // This prevents the 'jump' at the start of the scroll.
      this.currentTop = this.cache.headerHeight + 20;
      this.element.style.top = `${this.currentTop}px`;
      this.element.style.willChange = 'top';

      // 3. Watch for height changes
      this.resizeObserver = new ResizeObserver(() => {
        this.measure();
        this.update(window.scrollY);
      });
      this.resizeObserver.observe(this.element);
      this.resizeObserver.observe(document.body);

      // 4. Scroll listener
      window.addEventListener('scroll', this.onScroll, { passive: true });
      
      // 5. Directional check
      this.update(window.scrollY);
    }

    measure() {
      if (!this.element.isConnected) return;
      this.cache.elementHeight = this.element.offsetHeight;
      this.cache.viewportHeight = window.innerHeight;
      this.cache.headerHeight = this.header ? this.header.offsetHeight : 0;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update(window.scrollY);
        this.ticking = false;
      });
    }

    update(scrollY) {
      if (window.innerWidth < 750) {
         this.element.style.top = '';
         return;
      }

      const delta = scrollY - this.lastScrollY;
      this.lastScrollY = scrollY;

      const stickyMax = this.cache.headerHeight + 20;
      const stickyMin = this.cache.viewportHeight - this.cache.elementHeight - 20;

      // If the column is shorter than the viewport, stay at the top.
      if (this.cache.elementHeight + stickyMax <= this.cache.viewportHeight) {
        this.currentTop = stickyMax;
      } else {
        // Move by scroll delta
        this.currentTop -= delta;
        
        // Clamp between bottom and top bounds
        if (this.currentTop < stickyMin) this.currentTop = stickyMin;
        if (this.currentTop > stickyMax) this.currentTop = stickyMax;
      }

      this.element.style.top = `${this.currentTop}px`;
    }
  }

  function init() {
    document.querySelectorAll('.product__info-container.product__column-sticky').forEach(el => {
      if (el._stickyInited) return;
      new LightweightSticky(el);
      el._stickyInited = true;
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
